import React from "react";
import classes from "./ConnectWithUsForm.module.css";
import { Form, Input } from "antd";
import TextArea from "antd/es/input/TextArea";
import { LoadingOutlined } from "@ant-design/icons";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";

const ConnectWithUsForm = ({ form, loading, onFinish, showPar = true }) => {
  return (
    <div data-aos="fade-down" data-aos-delay="200">
      {showPar && (
      <p
        className={classes.description}
      >
        We’re committed to providing prompt assistance and ensuring you can
        easily reach us for all your healthcare needs. Whether you have
        questions, need to book an appointment, or want to know more about our
        services, we are here to help. Contact us through any of the following
        options.
      </p>
      )}
      <h4 className={classes.question}>Do you have any query?</h4>
      <Form
        layout="vertical"
        form={form}
        //   onFinish={onFinish}
      >
        <div className={classes.formInputContainer}>
          <Form.Item
            className={classes.inputHalf}
            label="First Name"
            name="name"
            rules={[
              {
                required: true,
                message: "Please enter your First name!",
              },
            ]}
          >
            <Input placeholder="First Name" />
          </Form.Item>

          <Form.Item
            className={classes.inputHalf}
            label="Last Name"
            name="lastName"
            rules={[
              { required: false, message: "Please enter your Last name!" },
            ]}
          >
            <Input placeholder="Enter your Last name" />
          </Form.Item>
        </div>
        <div className={classes.formInputContainer}>
          <Form.Item
            className={classes.inputHalf}
            label="Email"
            name="email"
            rules={[
              {
                type: "email",
                message: "Please enter a valid email!",
              },
              {
                required: true,
                message: "Please enter your email!",
              },
            ]}
          >
            <Input placeholder="Email" />
          </Form.Item>

          <Form.Item
            className={`${classes.inputHalf} phone-input`}
            label="Phone Number"
            name="phoneNumber"
            rules={[
              {
                required: true,
                message: "Please enter your Phone number!",
              },
            ]}
          >
            <PhoneInput
              country={"in"}
              enableSearch={true}
              specialLabel=""
              disableDropdown={false}
              countryCodeEditable={true}
              placeholder={"Phone Number"}
            />
            {/* <Input placeholder="Phone Number" /> */}
          </Form.Item>
        </div>
        <Form.Item
          className={`${classes.inputFull} text-area`}
          label="Message"
          name="message"
          rules={[
            {
              required: true,
              message: "Please enter your Message!",
            },
          ]}
        >
          <TextArea placeholder="Message" rows={5} className="text-area" />
        </Form.Item>
        <Form.Item>
          <button
            className={`${classes.submitButton} primaryHover`}
            onClick={() => onFinish()}
            disabled={loading}
          >
            {loading && <LoadingOutlined />} Send Message
          </button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ConnectWithUsForm;
